import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { CardType } from '../../../../../../types/cardType';
import { getPaySystemName } from '../../../../../../utils/cashier';
import { customHelpMethods } from '../../../../data';

import {
  TXTWCL_For_more_help_with_N0X_visit_o_ELL,
  TXTWCL_If_you_choose_to_make_this_you_ELL,
  TXTWCL_Learn_more_XaXhereX_aXX,
  TXTWCL_Please_ensure_you_add_the_corr_ELL,
  TXTWCL_You_will_still_be_able_to_choo_ELL
} from './HelpSectionContent.messages.json';

const getResolver = (cardType: CardType, license: LicenceId) => {
  const resolver: Partial<Record<CardType, ResolverTag>> = {
    [CardType.AstropayWallet]: ResolverTag.RealMoneyAstropay,
    [CardType.BoletoAstropay]: ResolverTag.RealMoneyBoleto,
    [CardType.BoletoInovapay]: ResolverTag.RealMoneyBoleto,
    [CardType.ECheck]: ResolverTag.RealMoneyEchecks,
    [CardType.GamersCard]: ResolverTag.RealMoneyGamersCard,
    [CardType.MBookers]: ResolverTag.RealMoneyMoneyBookers,
    [CardType.MuchBetter]: ResolverTag.RealMoneyMuchBetter,
    [CardType.Neteller2]: ResolverTag.RealMoneyNeteller,
    [CardType.Pay4Fun]: ResolverTag.RealMoneyPay4Fun,
    [CardType.PStarsTopUp]: ResolverTag.RealMoneyPStarsTopUp,
    [CardType.Ricarica]:
      license === LicenceId.ITALY ? ResolverTag.RealMoneyRicarica : ResolverTag.RealMoneyPSRecarga,
    [CardType.Skrill1Tap]: ResolverTag.RealMoneySkrill1Tap,
    [CardType.Todito]: ResolverTag.RealMoneyTodito
  };

  return resolver[cardType] || ResolverTag.HelpCenterDepositDeletingUpdatingCardDetails;
};

const defaultText = (
  <>
    <Translation {...TXTWCL_If_you_choose_to_make_this_you_ELL} />{' '}
    <Translation {...TXTWCL_You_will_still_be_able_to_choo_ELL} />{' '}
    <Translation
      values={{
        a: (msg: string) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenterDepositDeletingUpdatingCardDetails}>
            {msg}
          </ResolverLink>
        )
      }}
      {...TXTWCL_Learn_more_XaXhereX_aXX}
    />
  </>
);

const getCustomText = (license: LicenceId, cardType: CardType, i18nSystemName: string) => (
  <>
    <Translation {...TXTWCL_Please_ensure_you_add_the_corr_ELL} />{' '}
    <Translation
      {...TXTWCL_For_more_help_with_N0X_visit_o_ELL}
      values={{
        0: i18nSystemName,
        a: (msg: string) => (
          <ResolverLink resolverTag={getResolver(cardType, license)}>{msg}</ResolverLink>
        )
      }}
    />
  </>
);

const HelpSectionContent: React.FC = () => {
  const license = useSelector(select.account.getLicense);
  const {
    data: {
      paySystems,
      paySystemDetails: { type }
    }
  } = useWizardContext();
  const i18nSystemName = getPaySystemName(paySystems, type);

  return customHelpMethods.includes(type)
    ? getCustomText(license, type, i18nSystemName)
    : defaultText;
};

export default HelpSectionContent;
